// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tasks-item {
  border-radius: 10px;
  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));
  background: var(--on-primary, #fff);
  padding: 20px;
  padding-bottom: 0;
}
.tasks-item .title {
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: normal;
}
.tasks-item .subtitle {
  color: var(--secondary-on-surface, #98a2b3);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.25px;
  margin-bottom: 10px;
  margin-top: 6px;
}
.tasks-item .tasks-item-action-btn {
  height: 40px;
  width: 40px;
  padding: 0 !important;
}
.tasks-item-header {
  overflow: hidden;
}
.tasks-item .tasks-item-forms-more-title {
  padding: 14px 14px 14px 32px;
  color: #7f56d9;
}
.tasks-item .tasks-item-forms-row {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #101828;
  border-bottom: 1px solid #dadee4;
  padding: 8px 10px 6px 6px;
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
}
.tasks-item .tasks-item-forms-row.no-border {
  border-bottom: unset;
}
.tasks-item .tasks-item-forms-row-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-grow: 1;
}
.tasks-item .tasks-item-forms-row img {
  margin-right: 18px;
  flex-shrink: 0;
}
.tasks-item .dropdown-menu {
  padding: 5px !important;
}

.task-deleted-alert {
  width: max-content;
  right: 100px;
}
.task-deleted-alert .Toastify__toast-body {
  font-size: 18px;
  color: var(--Secondary-eading, #101828);
  font-weight: 600;
}
.task-deleted-alert .Toastify__toast-body .Toastify__toast-icon {
  margin-right: 40px;
}
.task-deleted-alert .Toastify__progress-bar--success {
  background: #12b76a !important;
}
.task-deleted-alert .close-alert-btn {
  margin: 0 10px;
}
.task-deleted-alert .close-alert-btn:hover {
  opacity: 0.3;
}

.task-run-alert {
  width: max-content;
  right: 100px;
}
.task-run-alert .Toastify__toast-body {
  font-size: 18px;
  color: var(--Secondary-eading, #101828);
  font-weight: 600;
}
.task-run-alert .Toastify__toast-body .Toastify__toast-icon {
  margin-right: 40px;
}
.task-run-alert .Toastify__progress-bar--success {
  background: #12b76a !important;
}
.task-run-alert .close-alert-btn {
  margin: 0 10px;
}
.task-run-alert .close-alert-btn:hover {
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/pages/tasks/tasks-list-page/styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qEAAA;EACA,mCAAA;EACA,aAAA;EACA,iBAAA;AACF;AACE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;AAEE;EACE,2CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,WAAA;EACA,qBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAMI;EACE,4BAAA;EACA,cAAA;AAJN;AAOI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gCAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;AALN;AAOM;EACE,oBAAA;AALR;AAQM;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AANR;AASM;EACE,kBAAA;EACA,cAAA;AAPR;AAYE;EACE,uBAAA;AAVJ;;AAcA;EAcE,kBAAA;EACA,YAAA;AAxBF;AAUE;EACE,eAAA;EACA,uCAAA;EACA,gBAAA;AARJ;AAUI;EACE,kBAAA;AARN;AAWE;EACE,8BAAA;AATJ;AAeE;EAKE,cAAA;AAjBJ;AAaI;EACE,YAAA;AAXN;;AAkBA;EAcE,kBAAA;EACA,YAAA;AA5BF;AAcE;EACE,eAAA;EACA,uCAAA;EACA,gBAAA;AAZJ;AAcI;EACE,kBAAA;AAZN;AAeE;EACE,8BAAA;AAbJ;AAmBE;EAKE,cAAA;AArBJ;AAiBI;EACE,YAAA;AAfN","sourcesContent":[".tasks-item {\n  border-radius: 10px;\n  border: 1px solid var(--secondary-outline, rgba(152, 162, 179, 0.36));\n  background: var(--on-primary, #fff);\n  padding: 20px;\n  padding-bottom: 0;\n\n  .title {\n    font-weight: 600;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: normal;\n  }\n\n  .subtitle {\n    color: var(--secondary-on-surface, #98a2b3);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.25px;\n    margin-bottom: 10px;\n    margin-top: 6px;\n  }\n\n  .tasks-item-action-btn {\n    height: 40px;\n    width: 40px;\n    padding: 0 !important;\n  }\n\n  &-header {\n    overflow: hidden;\n  }\n\n  .tasks-item-forms {\n    &-more-title {\n      padding: 14px 14px 14px 32px;\n      color: #7f56d9;\n    }\n\n    &-row {\n      font-size: 14px;\n      font-weight: 500;\n      line-height: 20px;\n      color: #101828;\n      border-bottom: 1px solid #dadee4;\n      padding: 8px 10px 6px 6px;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      overflow: hidden;\n\n      &.no-border {\n        border-bottom: unset;\n      }\n\n      &-name {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        flex-grow: 1;\n      }\n\n      img {\n        margin-right: 18px;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  .dropdown-menu {\n    padding: 5px !important;\n  }\n}\n\n.task-deleted-alert {\n  .Toastify__toast-body {\n    font-size: 18px;\n    color: var(--Secondary-eading, #101828);\n    font-weight: 600;\n\n    .Toastify__toast-icon {\n      margin-right: 40px;\n    }\n  }\n  .Toastify__progress-bar--success {\n    background: #12b76a !important;\n  }\n\n  width: max-content;\n  right: 100px;\n\n  .close-alert-btn {\n    &:hover {\n      opacity: 0.3;\n    }\n\n    margin: 0 10px;\n  }\n}\n\n.task-run-alert {\n  .Toastify__toast-body {\n    font-size: 18px;\n    color: var(--Secondary-eading, #101828);\n    font-weight: 600;\n\n    .Toastify__toast-icon {\n      margin-right: 40px;\n    }\n  }\n  .Toastify__progress-bar--success {\n    background: #12b76a !important;\n  }\n\n  width: max-content;\n  right: 100px;\n\n  .close-alert-btn {\n    &:hover {\n      opacity: 0.3;\n    }\n\n    margin: 0 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
